import React from 'react';
import { XIcon } from 'lucide-react';
const problems = ['Historias clínicas en papeles sueltos que se pierden', 'No sabés qué pacientes tienen vacunas vencidas', 'El inventario de medicamentos siempre desactualizado', 'Turnos anotados en cualquier lado sin control real', 'Datos del paciente que tenés que buscar 10 minutos', 'Cada veterinario de tu equipo registra diferente'];
export function Problem() {
  return <section className="bg-mint py-12 px-6" data-id="element-260">
      <div className="max-w-md mx-auto space-y-8" data-id="element-261">
        <h2 className="text-2xl font-bold text-navy text-center" data-id="element-262">
          ¿Cuánto tiempo más vas a perder con el desorden?
        </h2>

        <p className="text-navy text-center text-[15px]" data-id="element-263">
          Sin un sistema claro, siempre terminás igual.
        </p>

        <div className="space-y-3" data-id="element-264">
          {problems.map((problem, index) => <div key={index} className="flex items-start gap-3 bg-white rounded-lg p-4" data-id="element-265">
              <XIcon className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-266" />
              <span className="text-navy text-[15px] leading-relaxed" data-id="element-267">
                {problem}
              </span>
            </div>)}
        </div>

        <div className="bg-teal text-white rounded-xl p-6 text-center space-y-2" data-id="element-268">
          <p className="text-[15px] leading-relaxed" data-id="element-269">
            No es desorganización. Es falta de un sistema.
          </p>
          <p className="font-bold" data-id="element-270">
            Con el Kit Veterinario Elite, tu clínica funciona como tiene que
            funcionar. 🐾
          </p>
        </div>
      </div>
    </section>;
}